import React, { createContext, useContext, useState } from "react";
import { IGalleryBannerContext, IGalleryBannerData, IGalleryImageContext, IGalleryImageData } from "../exports/interfaces";

const GalleryBannerContext = createContext<IGalleryBannerContext>({
  galleryBannerData: [],
  setGalleryBannerData: () => null,
});
export const useGalleryBannerContext = () => useContext(GalleryBannerContext);

export const GalleryBannerProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [galleryBannerData, setGalleryBannerData] = useState<IGalleryBannerData[]>([]);

  return (
    <GalleryBannerContext.Provider value={{ galleryBannerData, setGalleryBannerData }}>
      {children}
    </GalleryBannerContext.Provider>
  );
};

const GalleryImageContext = createContext<IGalleryImageContext>({
    galleryImageData: [],
    setGalleryImageData: () => null,
  });
  export const useGalleryImageContext = () => useContext(GalleryImageContext);
  
  export const GalleryImageProvider = ({
    children,
  }: {
    children: React.ReactNode;
  }) => {
    const [galleryImageData, setGalleryImageData] = useState<IGalleryImageData[]>([]);
  
    return (
      <GalleryImageContext.Provider value={{ galleryImageData, setGalleryImageData }}>
        {children}
      </GalleryImageContext.Provider>
    );
  };